var _defs, _path, _polygon, _path2, _path3, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect, _polygon3, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShibaHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.24 347.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d38f19;}.cls-2{fill:#ede4d6;}.cls-3{fill:#c37c12;}.cls-4{fill:#dbd2c7;}.cls-5{fill:#3b3a3a;}.cls-6{fill:#d86444;}.cls-7{fill:#555454;}.cls-8{fill:none;}.cls-9{fill:#c97e1c;}.cls-10{fill:#eee9d7;}.cls-11{fill:#743f2a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.4,130s21.19,14.75,25.6,14.57,11.86-9.27,11.86-9.27l4.35,14.94h17.3l4.36-14.94s7.44,9.08,11.85,9.27S196.33,130,196.33,130s12.95,2,22.72,16.67a95.07,95.07,0,0,0,3.56-12.17C210.63,100.14,178.47,78,178.47,78H108.69s-32.15,22.19-44.14,56.52a104.46,104.46,0,0,0,5.34,16.86C79.77,132.4,95.4,130,95.4,130Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "332.59 300.93 332.63 299.46 332.59 299.5 332.59 300.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.68,236.42c-1.15-.41-6.75,0-13.38.56,4.54,3,7.5,8.3,8.63,14a65.56,65.56,0,0,1,2.23,11.4l6.52-6.28s9.7-.49,13.12-5.34S376.82,237.53,373.68,236.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.3,237c-11.45,1.06-26,2.89-26,2.89l-1.68,59.59,38.53-37.13c.82-3.93-.13-9.53-1.09-13C368.94,243.64,364.84,240,360.3,237Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "334.31 239.87 352.05 237.92 339.52 268.59 334.31 239.87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.28,296.37s22.82,10.1,33.67,9,19.11-9,19.11-9L274.39,275Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.23,167.43c17.22,8.37,28.07,23.72,32.94,35.33s-15.58,96.74-15.58,96.74-10,9.13-28.21,4.69c-10.85-2.64-39.3-21.33-39.3-21.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.65,272.37s-9.27,15.55,0,26.33l-26.57-15.84S281.24,265.79,291.65,272.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.23,159.67s36.5-19.89,40.5-37.39,4.5-31,2-41-22,3-38.5-10.5-20.45-34.5-7-54C262-1.56,302.34-7,329.73,11.28c25.5,17,45.5,64.7,23.64,109.8-13.72,28.29-35.64,37.57-72.64,43.13S252.23,159.67,252.23,159.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.45,155.32c-35.18-4.22-85.33,6.64-85.33,6.64l-96.21,8.61S63.7,224.84,55.09,264.89L34.87,282.38c8,3.22,16,5.53,27.23,13.29,7.49,5.16,7.49,9.82,12.07,13.39a99,99,0,0,0,22.11-23.21s63.32,50.53,91.17,49.78S238.13,318,246,310.55s31.44-33.31,45.66-38.18,23.58-104.94,23.58-104.94S300.63,159.54,265.45,155.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.58,267.83c69.5-45.94,68.19-104.77,68.19-104.77l2-6.52c-19,2.25-33.67,5.42-33.67,5.42l-96.21,8.61S77,189.05,69.59,212.4c4.19,42.23,26.69,73.45,26.69,73.45s63.32,50.53,91.17,49.78S238.13,318,246,310.55c-17,4.42-41.94,13.51-58.54,5.72C172.24,270.86,143.58,267.83,143.58,267.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.58,267.83s8.83,10.56,14,15.7c0,0-15.91,4.84-20.19,6.7-2.05.88-6.09,5.58-10.37,10.81,12.46-1,24.05-3,30.73,8.45,2.88,5.29,5.83,8.58,5.66,13.79.59-.6.91-.95.91-.95s30.7,2.57,35,1.14,32.53-55.64,32.53-55.64S199.67,232.17,143.58,267.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.87,282.38,21.78,293.71s-17.59-1.87-21,1.5,4.49,18,8.23,20.58S38.62,324.4,43.86,324c3.4-.24,16.39-4.42,30.31-15a24.89,24.89,0,0,0-5.79-11.84C59.11,287.18,47.24,283.42,34.87,282.38Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.05,315.79s-1.45-6.3,7.68-6.3,18.76,13.56,18.76,13.56S18.21,320.1,9.05,315.79Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.65,302c1.3,2.83,1,5.75-.66,6.51s-4.07-.92-5.36-3.75-1-5.75.66-6.51S8.36,299.19,9.65,302Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.57,302.13c.21,2.93-1.11,5.4-2.94,5.53s-3.46-2.14-3.67-5.07,1.12-5.4,2.94-5.53S18.37,299.21,18.57,302.13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.65,304.5c.18,2.63-1.13,4.87-2.92,5s-3.39-1.91-3.57-4.54,1.12-4.86,2.91-5S26.46,301.87,26.65,304.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.68,307.49c-6.67-11.44-21.32-10.93-32.62-6.45-4.67,5.71-9.62,12-12.55,14.73-5.61,5.13-19.6,12.55-18.74,16.26s11,19.4,30.9,14.55c17.26-4.21,32.93-19.36,36.78-23.3A30.22,30.22,0,0,0,159.68,307.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.69,78s-32.15,22.19-44.14,56.52c0,0,14.19,71.93,79,71.93s79-71.93,79-71.93C210.63,100.14,178.47,78,178.47,78Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.36,135.19s-7.69,3.68-11.2,2.35-5.4-5-4.19-8.18,5-4.69,8.55-3.36S127.36,135.19,127.36,135.19Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.67,119.37c.63-1.73,8.64-3.21,12.24,1.14a8.42,8.42,0,0,1,0,10.57C130.77,132.05,118.79,121.83,119.67,119.37Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.36,135.19s7.69,3.68,11.21,2.35,5.39-5,4.18-8.18-5-4.69-8.55-3.36S164.36,135.19,164.36,135.19Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.05,119.37c-.62-1.73-8.64-3.21-12.23,1.14a8.39,8.39,0,0,0,0,10.57C161,132.05,172.93,121.83,172.05,119.37Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.42,208.89c47.9,0,68.32-41.74,75.63-62.25C209.28,132,196.33,130,196.33,130s-21.19,14.75-25.61,14.57-11.85-9.27-11.85-9.27l-4.36,14.94h-17.3l-4.35-14.94s-7.45,9.08-11.86,9.27S95.4,130,95.4,130s-15.63,2.43-25.51,21.36C78.48,172.59,99,208.89,143.42,208.89Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.43,167.43s-5.29,11.92-7.56,13.43-6,1.71-6,1.71-3.73-.19-6-1.71-7.57-13.43-7.57-13.43Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.22,155.32s-8.89,17.59-15.33,17.78-16-5.67-16-5.67-9.6,5.86-16,5.67-15.32-17.78-15.32-17.78Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 145.36,
    y: 159.67,
    width: 1,
    height: 7.76
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "100.42 99.68 100.42 99.68 100.42 99.68 100.42 99.68"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.07,84.37S98.37,55,89.85,56.55,76.23,85.69,76.23,93.26s5.11,19.11,5.11,19.11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M108.48,69.71h0c-6.7-7.07-14.41-13.9-18.63-13.15C83.49,57.69,79,73.41,77.18,84.43,79,95.51,98.42,100.33,101.5,98.16h0C104.58,96,114.34,76.64,108.48,69.71Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.5,98.16s-15.21-17.6-8.93-21.73S101.5,98.16,101.5,98.16Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.88,84.37S190.58,55,199.09,56.55s13.63,29.14,13.63,36.71-5.11,19.11-5.11,19.11Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M180.47,69.71h0c6.7-7.07,14.4-13.9,18.62-13.15,6.37,1.14,10.83,16.86,12.68,27.88-1.83,11.08-21.24,15.9-24.32,13.73h0C184.36,96,174.61,76.64,180.47,69.71Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M187.45,98.16s15.2-17.6,8.93-21.73S187.45,98.16,187.45,98.16Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.18,236.42,124.3,245l11.4-7.69s-7.14,14.52-11.26,14.68S113.18,236.42,113.18,236.42Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156,150.9c0,4.84-4.55,8.77-10.17,8.77s-10.16-3.93-10.16-8.77,4.55-4.47,10.16-4.47S156,146.05,156,150.9Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.58,173.61c-6,0-14.13-4.66-15.72-5.6-1.62,1-10.06,5.74-16,5.59-6.66-.19-15.39-17.33-15.76-18l.89-.46c.09.18,8.83,17.34,14.9,17.51,6.24.18,15.66-5.54,15.75-5.6l.26-.16.26.16c.1.06,9.53,5.78,15.76,5.6,6.06-.17,14.8-17.33,14.89-17.51l.89.46c-.36.72-9.1,17.86-15.75,18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShibaHappy);
export default __webpack_public_path__ + "static/media/shiba-happy.2e6591468fb146de9b2eb4e16792919e.svg";
export { ForwardRef as ReactComponent };